import React, { useContext } from "react";
import { APIContext } from "../../Contexts/APIContext";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import QaiScorecardChallengeNoteViewModel, { QaiScorecardChallengeNoteType } from "./ViewModels/QaiScorecardChallengeNoteViewModel";
import TeamLeaderChallengePageButtons from "../TeamLeaderView/TeamLeaderChallengeButtons";
import GetChallengeNoteViewModel from "./ViewModels/GetChallengeNoteViewModel";

interface IQaiChallengeSubmitButtonsProps {
    noteViewModel: QaiScorecardChallengeNoteViewModel
    notesViewModel: GetChallengeNoteViewModel[]
    setNoteViewModel: (value: QaiScorecardChallengeNoteViewModel) => void
    getChallengeNotes: () => void
    view: string
}

export default function QaiChallengeSubmitButtons({
    noteViewModel,
    notesViewModel,
    setNoteViewModel,
    getChallengeNotes,
    view
}: IQaiChallengeSubmitButtonsProps) {
    const { post, showMessage, loading } = useContext(APIContext);

    const noteSubmitHandler = (isEscalated: boolean) => {
        if (!noteViewModel?.note) {
            showMessage('warning', "You must fill out the note field before submitting");
        }
        else {
            const noteWithTypeViewModel = { ...noteViewModel }
            if (isEscalated) {
                noteWithTypeViewModel.type = QaiScorecardChallengeNoteType.escalated
            }
            post('QaiScorecardChallenge',
                'CreateNote',
                noteWithTypeViewModel,
                () => {
                    setNoteViewModel({
                        ...noteViewModel,
                        note: ''
                    });
                    showMessage('success', 'Note submitted');
                    getChallengeNotes();
                });
        }
    }

    return (
        <Grid container
            size={12}
            height="5%"
            paddingTop={1}
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={1}>
            <Grid>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={() => noteSubmitHandler(false)}>
                    Add note
                </Button>
            </Grid>
            {
                view === 'Team Leader' &&
                <TeamLeaderChallengePageButtons noteSubmitHandler={noteSubmitHandler} notesViewModel={notesViewModel} />
            }
        </Grid>
    )
}